import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicEventCategory } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const fetchEventCategories = async ({
  organisationId,
}: {
  organisationId: string;
}): Promise<PublicEventCategory[]> => {
  const response = await axiosClient.get(`${organisationId}/event-categories`);
  return response.data;
};

export function fetchEventCategoriesKey({
  organisationId,
}: {
  organisationId: string;
}) {
  return ["event-categories", organisationId];
}

export function useFetchEventCategories(
  { organisationId }: { organisationId: string },
  queryOptions?: Partial<UseQueryOptions<PublicEventCategory[], HttpError>>,
) {
  return useQuery({
    queryKey: fetchEventCategoriesKey({ organisationId }),
    queryFn: () =>
      fetchEventCategories({
        organisationId,
      }),
    enabled: !!organisationId,
    ...queryOptions,
  });
}
